import { render, staticRenderFns } from "./dragComponents.vue?vue&type=template&id=50e94068&"
import script from "./dragComponents.vue?vue&type=script&lang=js&"
export * from "./dragComponents.vue?vue&type=script&lang=js&"
import style0 from "./dragComponents.vue?vue&type=style&index=0&id=50e94068&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports